export default "__VITE_ASSET__CEmitnn3__"